import { FC } from "react";
import styles from "./MenuTabs.module.scss";
import { routesAdmin, routesClient, routesModel } from "./constants";
import { Link, useLocation } from "react-router-dom";
import { TUserType } from "../../types/user";
import { match } from "path-to-regexp";

export const MenuTabs: FC<{ type: TUserType }> = ({ type }) => {
  const router = useLocation();
  const path = router.pathname.split("/")[1];

  return (
    <div className={styles.tabs}>
      <ul className={styles.list}>
        {type === "admin" &&
          routesAdmin.map((item, index) => (
            <li
              key={index}
              className={`${styles.list_item} ${
                router.pathname === `/${path}` + item.path ||
                (item.path === "/chat" && router.pathname.includes(item.path))
                  ? styles.list_item_active
                  : ""
              }`}
            >
              <Link
                to={`/${path}` + item.path}
                className={`${styles.link} ${
                  router.pathname === `/${path}` + item.path ||
                  (item.path === "/chat" && router.pathname.includes(item.path))
                    ? styles.link_active
                    : ""
                }`}
              >
                <p>{item.name}</p>
              </Link>
            </li>
          ))}
        {type === "model" &&
          routesModel.map((item, index) => (
            <li
              key={index}
              className={`${styles.list_item}  ${
                router.pathname === `/${path}` + item.path ||
                (item.path === "/chat" && router.pathname.includes(item.path))
                  ? styles.list_item_active
                  : ""
              }`}
            >
              <Link
                to={`/${path}` + item.path}
                className={`${styles.link}  ${
                  router.pathname === `/${path}` + item.path ||
                  (item.path === "/chat" && router.pathname.includes(item.path))
                    ? styles.link_active
                    : ""
                }`}
              >
                <p>{item.name}</p>
              </Link>
            </li>
          ))}
        {type === "client" &&
          routesClient.map((item, index) => (
            <li
              key={index}
              className={`${styles.list_item} ${
                match(`/${path}${item.path}`, { end: item.path === "" })(
                  router.pathname,
                ) && styles.list_item_active
              }`}
            >
              <Link
                to={`/${path}${item.path}`}
                className={`${styles.link} ${
                  match(`/${path}${item.path}`, { end: item.path === "" })(
                    router.pathname,
                  ) && styles.link_active
                }`}
              >
                <p>{item.name}</p>
              </Link>
            </li>
          ))}
      </ul>
    </div>
  );
};
